import { render } from "./data-sales-person.vue?vue&type=template&id=3c5d5958"
import script from "./data-sales-person.vue?vue&type=script&lang=js"
export * from "./data-sales-person.vue?vue&type=script&lang=js"
script.render = render

export default script